import { makeStyles } from 'tss-react/mui';

const itemsGap = '24px';
const background = '#9e9e9e';
const dotSize = '8px';
const topOffset = '10px';


export const useStyles = makeStyles()(() => ({
  activityRow: {
    marginBottom: 24
  },
  progressBar: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden'
  },
  dot: {
    position: 'static',
    background: background,
    borderRadius: '100px',
    width: 8,
    height: 8,
    marginTop: 10
  },
  progressLine: {
    '&::after': {
      content: '""',
      position: 'absolute',
      top: topOffset,
      left: 3.5,
      width: 2,
      height: `calc(100% + ${itemsGap} + ${dotSize} / 2)`,
      borderLeft: `1px dashed ${background}`
    }
  },
}));
